import {ReactNode, useState} from "react";
import {css} from "@panda/css";

import {ChevronDownIcon, ChevronUpIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";

import {Collapsible} from "@/components/collapsible/Collapsible";

interface IProps {
    children: ReactNode;
    sectionId: string;
    title: string;
}

export const HomeMatchPreferencesSurveySection = (props: IProps) => {
    const {children, sectionId, title} = props;
    const [isExpanded, setIsExpanded] = useState(true);
    const [shouldScrollIntoView, setShouldScrollIntoView] = useState(false);
    const ChevronIcon = isExpanded ? ChevronUpIcon : ChevronDownIcon;

    const toggle = () => {
        setIsExpanded((isCurrentlyExpanded) => {
            if (!isCurrentlyExpanded) setShouldScrollIntoView(true);

            return !isCurrentlyExpanded;
        });
    };

    return (
        <Collapsible
            allowOverflow
            className={sectionStyle}
            header={
                <button
                    aria-expanded={isExpanded}
                    className={headerStyle}
                    data-testid={`${KM_PREFERENCES_FORM_TEST_IDS.SECTION}-${sectionId}`}
                    onClick={toggle}
                    type="button"
                >
                    <Text as="span" preserveFontSize variant="headline_7">
                        {title}
                    </Text>
                    <ChevronIcon size="1.6" />
                </button>
            }
            isExpanded={isExpanded}
            shouldScrollIntoView={shouldScrollIntoView}
        >
            <div className={bodyStyle}>{children}</div>
        </Collapsible>
    );
};

const sectionStyle = css({
    borderTop: "1px solid var(--colors-gray-300)"
});

const headerStyle = css({
    alignItems: "center",
    background: "transparent",
    border: 0,
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    pb: 3,
    pl: 0,
    pt: 5,
    width: "100%"
});

const bodyStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    pb: 3
});
import {ReactNode, useState} from "react";
import {css} from "@panda/css";

import {ChevronDownIcon, ChevronUpIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";

import {Collapsible} from "@/components/collapsible/Collapsible";

interface IProps {
    children: ReactNode;
    sectionId: string;
    title: string;
}

export const HomeMatchPreferencesSurveySection = (props: IProps) => {
    const {children, sectionId, title} = props;
    const [isExpanded, setIsExpanded] = useState(true);
    const [shouldScrollIntoView, setShouldScrollIntoView] = useState(false);
    const ChevronIcon = isExpanded ? ChevronUpIcon : ChevronDownIcon;

    const toggle = () => {
        setIsExpanded((isCurrentlyExpanded) => {
            if (!isCurrentlyExpanded) setShouldScrollIntoView(true);

            return !isCurrentlyExpanded;
        });
    };

    return (
        <Collapsible
            allowOverflow
            className={sectionStyle}
            header={
                <button
                    aria-expanded={isExpanded}
                    className={headerStyle}
                    data-testid={`${KM_PREFERENCES_FORM_TEST_IDS.SECTION}-${sectionId}`}
                    onClick={toggle}
                    type="button"
                >
                    <Text as="span" preserveFontSize variant="headline_7">
                        {title}
                    </Text>
                    <ChevronIcon size="1.6" />
                </button>
            }
            isExpanded={isExpanded}
            shouldScrollIntoView={shouldScrollIntoView}
        >
            <div className={bodyStyle}>{children}</div>
        </Collapsible>
    );
};

const sectionStyle = css({
    borderTop: "1px solid var(--colors-gray-300)"
});

const headerStyle = css({
    alignItems: "center",
    background: "transparent",
    border: 0,
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    pb: 3,
    pl: 0,
    pt: 5,
    width: "100%"
});

const bodyStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 2,
    pb: 3
});
